import React, { Component } from "react";
import styles from "../orders/OrdersSearch.module.scss";
import SubNav from "../../../../shared/subnav/SubNav";
import { AVAILABLE_MARKETS } from "../orders/AvailableMarkets";
import BackToButton from "../../../../shared/backToButton/BackToButton";
import { withTranslation } from "react-i18next";
import commonStyles from "../../../../styles/common/CommonStyles.module.scss";
import Grid from "@material-ui/core/Grid";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import CustomDropdown from "../../../../shared/subnav/CustomDropdown";
import { IS_FORD_BRAND } from "../../../../utils/EmpUtil";
import { Link } from "react-router-dom";
import AuthenticationClient from "../../../../shared/clients/AuthenticationClient";

class NscSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMarket: undefined,
    };
  }

  componentDidMount() {
    this.setState({
      selectedMarket: this.props.user.market,
    });
    let defaultUserMarket = this.props.user.market.toUpperCase();

    if (!AVAILABLE_MARKETS.hasOwnProperty(defaultUserMarket)) {
      defaultUserMarket = "GBR";
    }

    this.setState({ selectedMarket: defaultUserMarket });
  }

  componentWillUnmount() {
    this.props.user.removeReadOnlyPermissions();
  }

  onSubmit = (props, dealer) => {
    this.updateCurrentDealer(props, dealer);
  };

  updateCurrentDealer = (props, dealer) => {
    AuthenticationClient.getNscReadOnlyPermissions(
      props.user,
      this.state.selectedMarket
    ).then((result) => {
      dealer.permissions = result;
      dealer.userType = "nsc";
      dealer.brand = props.userDetails.brand;
      dealer.market = this.state.selectedMarket;
      dealer.roles = props.userDetails.roles;
      dealer.fromPoNscSearch = true;
      dealer.fullName = this.state.selectedMarket;
      props.updateUserDetails(dealer);
    });
  };

  changeMarket = (e) => {
    this.setState({
      selectedMarket: e.target.value,
    });
  };

  render() {
    const isFordBrand = IS_FORD_BRAND(this.props.user.brand);
    return (
      <div>
        <section className="pageWrapper">
          {this.props.user.permissions.rolePermissions.hasOwnProperty(
            "searchLandingPage"
          ) && (
            <BackToButton
              backToUrl="/search"
              display={this.props.t("SearchWrapper.backToSearch")}
            />
          )}
          <SubNav
            dashboard={false}
            title={this.props.t("SearchWrapper.nscSearch")}
            {...this.props}
          />
          <div className={styles.bottomPadding}>
            <div className={styles.indent}>
              <p className={styles.nscSearchSubHeader}>
                {this.props.t("SearchWrapper.nscSubtitle")}
              </p>
              <form
                className={styles.form}
                id="valuationForm"
                onSubmit={() => {}}
              >
                <Grid container>
                  <Grid item md={4} className={styles.dropdownGridStyle}>
                    <HasPermissionTo
                      perform={["nscSearchMarketDropDown:view"]}
                      permissions={this.props.user.permissions.rolePermissions}
                      render={() => (
                        <CustomDropdown
                          {...this.props}
                          value={this.state.selectedMarket}
                          onChange={this.changeMarket}
                          dropDownValues={AVAILABLE_MARKETS}
                          isFordBrand={isFordBrand}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item md={3}>
                    <div className={styles.searchButtonMargin}>
                      <Link
                        data-testid="viewNscSearch"
                        to="/dashboard"
                        className={commonStyles.buttonLink}
                        onClick={() =>
                          this.onSubmit(this.props, this.props.userDetails)
                        }
                      >
                        {this.props.t("fieldView.search")}
                      </Link>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withTranslation("emp")(NscSearch);
